import { format as f } from "d3-format";
import mapKeys from "lodash/mapKeys";
import upperFirst from "lodash/upperFirst";
import DateFormat from "./dateFormat";

var numberMap = {
  0: "Zero",
  1: "One",
  2: "Two",
  3: "Three",
  4: "Four",
  5: "Five",
  6: "Six",
  7: "Seven",
  8: "Eight",
  9: "Nine"
};

var sortList = ["hour", "day", "date", "month", "year"];

var chartUtils = {
  defaultFormat: "{format}",
  defaultCurrencyPrefix: "{currency}",
  defaultYAxisFormat: "{yAxisFormat}",
  findValue: findInArray,
  findLink: findLink,
  format: formatNumber,
  formatDate: formatDate,
  toMonthNumber: getMonthNumber,
  toMonthName: getMonthName,
  toDayNumber: getDayNumber,
  toHourNumber: getHourNumber,
  toQuarterNumber: getQuarterNumber,
  getTimeMeridian: getTimeMeridian,
  inArray: isInArray,
  replaceAll: replaceAll,
  convertHexToRGB: convertHexToRGB,
  sortList: sortList,
  isSpecialSort: isSpecialSort,
  sort: sortArray,
  makeRelative: translate,
  findIndex: findIndex,
  getMinValue: getMinValue,
  getMaxValue: getMaxValue,
  sortByBaseSeries: sortByBaseSeries,
  getUnique: unique,
  getTop: getTop,
  getBottomX: getBottomX,
  getSubArray: getSubArray,
  getLabelColor: getLabelColor,
  getUpperFirst: getUpperFirst,
  tryJsonParse: tryJsonParse,
  compoundSort: compoundSortArray,
  getTooltipValue: function getTooltipValue(tooltipSettings, data) {
    var tipValue = data[tooltipSettings.Id];

    if (tipValue == null) tipValue = data[tooltipSettings.TipField];

    var aggregationType = tooltipSettings.AggregationType;

    if (aggregationType.trim().toLowerCase() == "unknown") aggregationType = "";

    if (aggregationType.trim().length == 0 && Number(tipValue) <= 1) tipValue = data[tooltipSettings.TipField];

    return tipValue == null ? "--" : tipValue;
  },
  buildTooltipText: function buildTooltipText(tooltipConfig, data, defaultTipText, defaultTipValue, defaultTipAggregation, displayTotalRecords) {
    var text = null;
    var includeDefaultTip = true;

    if (tooltipConfig != null) text = tooltipConfig.TooltipText;

    if (defaultTipText == null) defaultTipText = "";

    if (text == null || text.trim().length == 0) {
      if (data["counter"] != null && displayTotalRecords == true) return defaultTipText + '<br /><span class="tip-header"># items:</span><span class="tip-value"> ' + data["counter"] + "</span>";

      return defaultTipText;
    }

    if (tooltipConfig != null && tooltipConfig.TooltipConfigs.length > 0) {
      for (var index = 0; index < tooltipConfig.TooltipConfigs.length; index++) {
        var tipItem = tooltipConfig.TooltipConfigs[index];

        if (defaultTipValue != null && tipItem.TipField == defaultTipValue && (tipItem.AggregationType == defaultTipAggregation || tipItem.AggregationType == "")) includeDefaultTip = false;

        var tipValue = data[tipItem.Id];

        tipValue = this.format(tipValue, tipItem.ValueFormat, tipItem.CurrencySymbol, null, tipItem.BaseFormat, false);

        if (tipItem.Id != null && tipItem.Id.toLocaleLowerCase().indexOf("date") >= 0) tipValue = formatDate(tipValue, tipItem.ValueFormat);

        text = text.replace("{" + tipItem.TipField + "}", tipValue + " ");
      }

      text += "<br />";

      if (includeDefaultTip && defaultTipText != "") {
        text += defaultTipText;

        text += "<br />";
      }

      if (data["counter"] != null && displayTotalRecords == true) text += '<br /><span class="tip-header"># items:</span><span class="tip-value"> ' + data["counter"] + "</span>";
    }

    return text;
  },
  chartSeriesType: {
    bar: "Bar",
    line: "Line",
    area: "Area",
    scatterPlot: "ScatterPlot"
  },
  chartGridLine: {
    none: 0,
    both: 1,
    xaxis: 2, //xAxis in Chartutils xaixs in utils
    yaxis: 3 //yAxis in Chartutils yaixs in utils
  },
  pieHemisphere: {
    full: 0,
    top: 1,
    bottom: 2,
    left: 3,
    right: 4
  },
  aggregationTypes: {
    unknown: "Unknown",
    sum: "SUM",
    count: "COUNT",
    average: "AVERAGE",
    uniqueCount: "COUNTU"
  },
  legendLocation: {
    unknown: "Unknown",
    top: "Top",
    bottom: "Bottom",
    left: "Left",
    right: "Right"
  },
  labelPosition: {
    none: "",
    inside: "Inside",
    outside: "Outside"
  },
  baseFormat: {
    none: "None"
  },
  expressionOperators: {
    greaterthan: "GreaterThan",
    lessthan: "LessThan",
    equalto: "EqualTo",
    contains: "Contains",
    greaterthanorequalto: "GreaterThanorEqualTo",
    lessthanorequalto: "LessThanorEqualTo",
    notequalto: "NotEqualTo",
    startswith: "StartsWith",
    endswith: "EndsWith"
  },
  formatType: {
    fill: "FILL",
    border: "BORDER"
  },
  textJustification: {
    none: "None",
    left: "Left",
    right: "Right",
    center: "Center"
  },
  sortType: {
    none: "None",
    ascending: "Ascending",
    descending: "Descending"
  },
  makeStyleName: function makeStyleName(value) {
    if (typeof value.length == "undefined" || value.trim().length == 0 || value == "--") return "default-1";

    var text = replaceAll(value, " ", "").toLowerCase();

    text = replaceAll(text, "'", "");

    text = text.replace(/[^a-z0-9]+/g, "");

    if (/^[a-zA-Z]/.test(value)) return text.toLowerCase();

    var leadingValue = "";
    if (/^[0-9]+/.test(text)) leadingValue = text.match(/^[0-9]+/)[0];else {
      leadingValue = text.match(/^[a-zA-Z]+/)[0];
      var istext = true;
    }

    text = text.match(/^[0-9 a-zA-Z]+(.*)$/)[1];
    text = text.replace(/[^a-z0-9]+/g, "");
    var replacementText = "";
    if (!istext) {
      for (var index = 0; index < leadingValue.length; index++) {
        var number = Number(leadingValue[index]);
        replacementText += numberMap[number];
      }
      return (replacementText + text).toLowerCase();
    } else return (leadingValue + text).toLowerCase();
  },
  filter: filter,
  buildSeries: buildSeries,
  buildSeriesData: buildSeriesData,
  buildFormatExpression: buildFormatExpression
};
function tryJsonParse(data) {
  try {
    data = JSON.parse(data);
    //Handles if JSON.parse returns the integer
    if (Number.isInteger(data)) {
      var parseData = [];
      parseData.push(data.toString());
      data = parseData;
    }
  } catch (ex) {
    data = data;
  }
  return data;
}

function findInArray(array, fieldName, value) {
  if (array == null) return null;

  for (var i = 0; i < array.length; i++) {
    if (array[i][fieldName] != value) continue;

    return array[i];
  }

  return null;
}

function getMinValue(accumulator, fieldName) {
  if (accumulator == null || fieldName == null) return null;
  var minValue = 0;
  for (var index = 0; index < accumulator.length; index++) {
    minValue = Math.min(minValue, accumulator[index][fieldName]);
  }
  return minValue;
}

function getMaxValue(accumulator, fieldName) {
  if (accumulator == null || fieldName == null) return null;
  var maxValue = 0;
  for (var index = 0; index < accumulator.length; index++) {
    maxValue = Math.max(maxValue, accumulator[index][fieldName]);
  }
  return maxValue;
}

function unique(array, fieldName) {
  if (array == null) return array;

  var result = [];
  for (var index = 0; index < array.length; index++) {
    var val = array[index][fieldName];

    if (result.indexOf(val) >= 0) continue;

    result.push(val);
  }

  return result;
}

function findLink(array, fieldName1, value1, fieldName2, value2) {
  for (var i = 0; i < array.length; i++) {
    if (array[i][fieldName1] != value1 || array[i][fieldName2] != value2) continue;

    return array[i];
  }

  return null;
}

function determineStringWidth(str, font) {
  var f = font || "12px arial",
      o = $("<div>" + str + "</div>").css({
    position: "absolute",
    float: "left",
    "white-space": "nowrap",
    visibility: "hidden",
    font: f
  }).appendTo($("body")),
      w = o.width();

  o.remove();

  return w;
}

function isInArray(array, value) {
  for (var i = 0; i < array.length; i++) {
    if (array[i] == null && value == null) return true;

    if (array[i] == null) continue;

    if (value == null) continue;

    if (array[i].toString() == value.toString()) return true;
  }

  return false;
}
function formatNumber(val, displayFormat, currencyPrefix, referenceValue, baseFormat, isDecimalPercentNumber, categoryField) {
  if (val == null) return null;

  if (categoryField != null && categoryField.toLocaleLowerCase().indexOf("date") >= 0) {
    if (displayFormat != null && displayFormat != "") return formatDate(val, displayFormat);
  }

  if (isNaN(val)) return val;

  if ((displayFormat == null || displayFormat.trim().length == 0) && (currencyPrefix == null || currencyPrefix.trim().length == 0) && (baseFormat == null || baseFormat.trim().length == 0 || baseFormat == chartUtils.baseFormat.none)) return val.toString();

  var suffix = "";

  if (displayFormat != null && !isNaN(val) && displayFormat.toLocaleLowerCase() == "hms") return converttoHMS(val);

  if (displayFormat != null && !isNaN(val) && displayFormat.toLocaleLowerCase() == "ms") return converttoMS(val);

  if (currencyPrefix == null || currencyPrefix == this.defaultCurrencyPrefix) currencyPrefix = "";

  if (displayFormat == null || displayFormat.trim().length == 0 || displayFormat == this.defaultFormat) displayFormat = ",.0f";

  if (displayFormat.indexOf("%") > -1 && displayFormat.indexOf("f") > -1) {
    displayFormat = displayFormat.split("%")[0];
    suffix = "%";
  }

  if (displayFormat.indexOf("f") > -1) {
    var fIndex = displayFormat.indexOf("f");
    if (fIndex > 0) {
      var decimals = displayFormat.charAt(fIndex - 1);
      if (isNaN(decimals)) val = val.toFixed(2);
    }
  }

  try {
    if (referenceValue == null) referenceValue = val;

    var format = d3.format(displayFormat);
    var formattedValue = "";

    if (baseFormat != null) {
      switch (baseFormat.toLowerCase()) {
        case "k":
          formattedValue = currencyPrefix + format((val / 1000).toFixed(2)) + "K" + suffix;
          break;
        case "m":
          formattedValue = currencyPrefix + format((val / 1000000).toFixed(2)) + "M" + suffix;
          break;
        case "b":
          formattedValue = currencyPrefix + format((val / 1000000000).toFixed(2)) + "B" + suffix;
          break;
        case "d":
          {
            if (referenceValue >= 1000 && referenceValue < 1000000 || referenceValue > -1000000 && referenceValue <= -1000) formattedValue = currencyPrefix + format((val / 1000).toFixed(2)) + "K" + suffix;else if (referenceValue >= 1000000 && referenceValue < 1000000000 || referenceValue > -1000000000 && referenceValue <= -1000000) formattedValue = currencyPrefix + format((val / 1000000).toFixed(2)) + "M" + suffix;else if (referenceValue >= 1000000000 || referenceValue <= -1000000000) formattedValue = currencyPrefix + format((val / 1000000000).toFixed(2)) + "B" + suffix;
          }
          break;
      }
    }

    if (isDecimalPercentNumber) val = val * 100;

    if (formattedValue.length < 1) formattedValue = currencyPrefix + format(val) + suffix;

    if (formattedValue.length > 0) {
      if (val < 0) formattedValue = formattedValue.toString().replace("-", "(") + ")";
    }

    return formattedValue;
  } catch (e) {
    if (baseFormat != null) {
      switch (baseFormat.toLowerCase()) {
        case "k":
          formattedValue = currencyPrefix + (val / 1000).toFixed(2).toLocaleString() + "K" + suffix;
          break;
        case "m":
          formattedValue = currencyPrefix + (val / 1000000).toFixed(2).toLocaleString() + "M" + suffix;
          break;
        case "b":
          formattedValue = currencyPrefix + (val / 1000000000).toFixed(2).toLocaleString() + "B" + suffix;
          break;
        case "d":
          {
            if (referenceValue >= 1000 && referenceValue < 1000000 || referenceValue > -1000000 && referenceValue <= -1000) formattedValue = currencyPrefix + format((val / 1000).toFixed(2)) + "K" + suffix;else if (referenceValue >= 1000000 && referenceValue < 1000000000 || referenceValue > -1000000000 && referenceValue <= -1000000) formattedValue = currencyPrefix + format((val / 1000000).toFixed(2)) + "M" + suffix;else if (referenceValue >= 1000000000 || referenceValue <= -1000000000) formattedValue = currencyPrefix + format((val / 1000000000).toFixed(2)) + "B" + suffix;
          }
          break;
      }
    }

    if (isDecimalPercentNumber) val = val * 100;

    if (formattedValue.length < 1) formattedValue = currencyPrefix + val.toFixed(2).toLocaleString() + suffix;

    if (formattedValue.length > 0) {
      if (val < 0) formattedValue = formattedValue.toString().replace("-", "(") + ")";
    }
    return formattedValue;
  }
}

function replaceAll(text, find, replacement) {
  if (text == null) return null;

  text = text.toString();

  return text.split(find).join(replacement);
}

function getMonthNumber(date) {
  var monthNumber = Number(date);

  if (monthNumber > 0 && monthNumber <= 12) return monthNumber;

  if (Object.prototype.toString.call(date) === "[object Date]") if (!isNaN(d.getTime())) return new Date(date).getMonth();

  var shortName = date.toString().substring(0, 3).toLowerCase();

  switch (shortName) {
    case "jan":
      return 1;
    case "feb":
      return 2;
    case "mar":
      return 3;
    case "apr":
      return 4;
    case "may":
      return 5;
    case "jun":
      return 6;
    case "jul":
      return 7;
    case "aug":
      return 8;
    case "sep":
      return 9;
    case "oct":
      return 10;
    case "nov":
      return 11;
    case "dec":
      return 12;
    default:
      return -1;
  }

  return -1;
}

function getDayNumber(day) {
  if (!isNaN(day)) return day;

  switch (day.toLowerCase()) {
    case "sun":
    case "sunday":
      return 1;
    case "mon":
    case "monday":
      return 2;
    case "tue":
    case "tuesday":
      return 3;
    case "wed":
    case "wednesday":
      return 4;
    case "thu":
    case "thursday":
      return 5;
    case "fri":
    case "friday":
      return 6;
    case "sat":
    case "saturday":
      return 7;
    default:
      return -1;
  }
  return -1;
}

function getQuarterNumber(quarter) {
  if (!isNaN(quarter)) return quarter;

  switch (quarter) {
    case "Q1":
      return 1;
    case "Q2":
      return 2;
    case "Q3":
      return 3;
    case "Q4":
      return 4;
    case "Quarter1":
      return 1;
    case "Quarter2":
      return 2;
    case "Quarter3":
      return 3;
    case "Quarter4":
      return 4;
    default:
      return -1;
  }

  return -1;
}

function getMonthName(date) {
  var monthNumber = Number(date);

  if (isNaN(monthNumber) || monthNumber <= 0) {
    if (Object.prototype.toString.call(date) === "[object Date]") if (!isNaN(d.getTime())) monthNumber = new Date(date).getMonth();
  }

  if (monthNumber > 0 && monthNumber <= 12) {
    switch (monthNumber) {
      case 1:
        return "Jan";
      case 2:
        return "Feb";
      case 3:
        return "Mar";
      case 4:
        return "Apr";
      case 5:
        return "May";
      case 6:
        return "Jun";
      case 7:
        return "Jul";
      case 8:
        return "Aug";
      case 9:
        return "Sep";
      case 10:
        return "Oct";
      case 11:
        return "Nov";
      case 12:
        return "Dec";
    }
  }

  var shortName = date.toString().substring(0, 3).toLowerCase();

  switch (shortName) {
    case "jan":
      return "Jan";
    case "feb":
      return "Feb";
    case "mar":
      return "Mar";
    case "apr":
      return "Apr";
    case "may":
      return "May";
    case "jun":
      return "Jun";
    case "jul":
      return "Jul";
    case "aug":
      return "Aug";
    case "sep":
      return "Sep";
    case "oct":
      return "Oct";
    case "nov":
      return "Nov";
    case "dec":
      return "Dec";
    default:
      return null;
  }

  return null;
}

function sortArray(array, sortFieldName, temporalFieldName, inverseSort, isSimpleArray, ignoreTemporalSort) {
  array.sort(function (d1, d2) {
    var value1;
    var value2;
    if (isSimpleArray == null) isSimpleArray = false;
    if (temporalFieldName != null) {
      if (isSimpleArray) {
        value1 = d1;
        value2 = d2;
      } else {
        value1 = d1[temporalFieldName];
        value2 = d2[temporalFieldName];
      }

      if (temporalFieldName.toLocaleLowerCase().indexOf("month") >= 0) {
        var m1 = new Date(value1);
        var m2 = new Date(value2);
        if (isNaN(m1)) {
          m1 = chartUtils.toMonthNumber(value1);
          m2 = chartUtils.toMonthNumber(value2);
        }
        return m1 - m2;
      }

      if (temporalFieldName.toLocaleLowerCase().indexOf("year") >= 0) return value1 - value2;
    }

    if (isSimpleArray) {
      value1 = d1;
      value2 = d2;
    } else {
      value1 = d1[sortFieldName];
      value2 = d2[sortFieldName];
    }

    return getComparison(value1, value2, sortFieldName, inverseSort, ignoreTemporalSort);
  });
}

function getComparison(value1, value2, sortFieldName, inverseSort, ignoreTemporalSort) {
  var pattern = new RegExp("^[0-9]{1,2}[-/][0-9]{2,4}$");
  var oneDigitPrefix = new RegExp("^[0-9]{1}[-/][0-9]{2,4}$");
  var datePattern = new RegExp("^[0-9]{1,2}[-/][0-9]{1,2}[-/][0-9]{2,4}$");
  if (pattern.test(value1) && pattern.test(value2)) {
    if (oneDigitPrefix.test(value1)) value1 = "0" + value1;
    if (oneDigitPrefix.test(value2)) value2 = "0" + value2;

    var tempValue1 = value1.split(new RegExp("[-/]"));
    var tempValue2 = value2.split(new RegExp("[-/]"));
    value1 = tempValue1[1] + tempValue1[0];
    value2 = tempValue2[1] + tempValue2[0];
    return inverseSort ? value2.localeCompare(value1) : value1.localeCompare(value2);
  }

  if (!ignoreTemporalSort) {
    if (sortFieldName.toLocaleLowerCase().indexOf("hour") >= 0) {
      var d = new Date();
      var ds = d.toDateString();
      var d1Meridian = chartUtils.getTimeMeridian(value1);
      var d2Meridian = chartUtils.getTimeMeridian(value2);
      var d1Hour = chartUtils.toHourNumber(value1);
      var d2Hour = chartUtils.toHourNumber(value2);
      var t1 = new Date(ds + " " + d1Hour + ":00:00" + " " + d1Meridian);
      var t2 = new Date(ds + " " + d2Hour + ":00:00" + " " + d2Meridian);
      return inverseSort ? t2.getTime() - t1.getTime() : t1.getTime() - t2.getTime();
    }

    if (sortFieldName.toLocaleLowerCase().indexOf("date") >= 0 || datePattern.test(value1) && datePattern.test(value2)) {
      var tick1 = new Date(value1);
      var tick2 = new Date(value2);
      return inverseSort ? tick2 - tick1 : tick1 - tick2;
    }

    if (sortFieldName.toLocaleLowerCase().indexOf("day") >= 0) {
      var tick1 = chartUtils.toDayNumber(value1);
      var tick2 = chartUtils.toDayNumber(value2);
      return inverseSort ? tick2 - tick1 : tick1 - tick2;
    }

    if (sortFieldName.toLocaleLowerCase().indexOf("month") >= 0) {
      var m1 = new Date(value1);
      var m2 = new Date(value2);
      if (isNaN(m1)) {
        m1 = chartUtils.toMonthNumber(value1);
        m2 = chartUtils.toMonthNumber(value2);
      }
      return inverseSort ? m2 - m1 : m1 - m2;
    }

    if (sortFieldName.toLocaleLowerCase().indexOf("quarter") >= 0) {
      var q1 = chartUtils.toQuarterNumber(value1);
      var q2 = chartUtils.toQuarterNumber(value2);
      return inverseSort ? q2 - q1 : q1 - q2;
    }

    if (sortFieldName.toLocaleLowerCase().indexOf("year") >= 0) return inverseSort ? value2 - value1 : value1 - value2;
  }

  if (value1 != null & value2 != null && isNaN(value1) && isNaN(value2) && !(Object.is(value1, NaN) || Object.is(value2, NaN))) {
    return inverseSort ? value2.localeCompare(value1) : value1.localeCompare(value2);
  }

  if (inverseSort) return value1 - value2;

  return value2 - value1;
}

function compoundSortArray(array, sortOrderFields, sortOrders, isSimpleArray) {
  array.sort(fieldSorter(sortOrderFields, sortOrders, isSimpleArray));
}

function fieldSorter(sortOrderFields, sortOrders, isSimpleArray) {
  var maps = [];
  sortOrderFields.map(function (sortOrderField) {
    maps.push({
      sortFieldName: sortOrderField,
      dir: sortOrders[sortOrderField]
    });
  });
  return function (d1, d2) {
    var ret = 0;
    maps.some(function (sortField) {
      var sortFieldName = sortField.sortFieldName;
      var value1;
      var value2;
      if (isSimpleArray) {
        value1 = d1;
        value2 = d2;
      } else {
        value1 = d1[sortFieldName];
        value2 = d2[sortFieldName];
      }
      var inverseSort = sortField.dir != chartUtils.sortType.ascending;

      /*Following condition is needed to support
          default descending order sort of value axis
          in chart widgets */
      if (!isNaN(value1) && !isTemporalField(sortFieldName)) inverseSort = sortField.dir == chartUtils.sortType.ascending;

      ret = getComparison(value1, value2, sortFieldName, inverseSort);
      return ret !== 0;
    });
    return ret;
  };
}

function isTemporalField(fieldName) {
  if (fieldName == null) return;
  fieldName = fieldName.toLowerCase();
  return fieldName.indexOf("hour") >= 0 || fieldName.indexOf("day") >= 0 || fieldName.indexOf("date") >= 0 || fieldName.indexOf("year") >= 0 || fieldName.indexOf("quarter") >= 0 || fieldName.indexOf("month") >= 0;
}

function translate(value, reference, makeWholeNumber) {
  if (makeWholeNumber == null) makeWholeNumber = true;

  var result = reference * value;

  if (!makeWholeNumber) return result;

  return result.toFixed(0);
}

function sortByBaseSeries(baseSeries, accumulator, xFieldName) {
  var loopLength = Math.min(baseSeries.length, accumulator.length);

  for (var index = 0; index < loopLength; index++) {
    var baseXField = baseSeries[index][xFieldName];
    var valueIndex = findIndex(accumulator, xFieldName, baseXField);
    if (valueIndex != null) {
      // swap
      var temp = accumulator[index];
      accumulator[index] = accumulator[valueIndex];
      accumulator[valueIndex] = temp;
    }
  }
}

function findIndex(array, fieldName, value) {
  for (var i = 0; i < array.length; i++) {
    if (array[i][fieldName] != value) continue;
    return i;
  }
  return null;
}

function formatDate(value, format) {
  if (!format) return value;

  if (format.toString().trim().length == 0 || format.indexOf(",.") >= 0) return value;
  /*
  when date doesn't have a time stamp append a dummy time stamp
  for proper date cast in javascript   */
  if (value !== null && value.toString().indexOf(":") == -1) value += " 00:00:00";

  var dateVal = value;

  if (Object.prototype.toString.call(value) != "[object Date]") {
    dateVal = new Date(value);
    if (dateVal == "Invalid Date") dateVal = value;
  }

  return DateFormat.format.date(dateVal, format);
}

function converttoHMS(value) {
  var h = Math.floor(value / 3600);
  var m = Math.floor((value - h * 3600) / 60);
  var s = Math.floor(value - (h * 3600 + m * 60));
  return (h < 10 ? "0" + h : h) + ":" + (m < 10 ? "0" + m : m) + ":" + (s < 10 ? "0" + s : s);
}

function converttoMS(value) {
  var m = Math.floor(value / 60);
  var s = Math.floor(value - m * 60);
  return (m < 10 ? "0" + m : m) + ":" + (s < 10 ? "0" + s : s);
}

function getTop(count, array) {
  if (array.length < count) return array;

  var top = [];
  for (var index = 0; index < count; index++) {
    top.push(array[index]);
  }
  return top;
}

function getBottomX(count, array) {
  if (array.length < count) return array;

  var bottom = [];

  var start = array.length - count;
  var end = array.length;

  for (var index = start; index < end; index++) {
    bottom.push(array[index]);
  }
  return bottom;
}

function filter(array, fieldName, value) {
  if (array == null || fieldName == null || value == null) return array;

  var result = [];
  for (var index = 0; index < array.length; index++) {
    var item = array[index];

    if (item[fieldName] != value) continue;

    result.push(item);
  }

  return result;
}

function convertHexToRGB(color) {
  var r, g, b;
  if (color.charAt(0) == "#") {
    color = color.substr(1);
  }
  if (color.length == 3) {
    color = color.substr(0, 1) + color.substr(0, 1) + color.substr(1, 2) + color.substr(1, 2) + color.substr(2, 3) + color.substr(2, 3);
  }
  r = color.charAt(0) + "" + color.charAt(1);
  g = color.charAt(2) + "" + color.charAt(3);
  b = color.charAt(4) + "" + color.charAt(5);
  r = parseInt(r, 16);
  g = parseInt(g, 16);
  b = parseInt(b, 16);
  return r + ", " + g + ", " + b;
}

function buildSeries(refSeries, seriesName) {
  var seriesColor = d3.scale.category20();
  if (refSeries == null || seriesName == null) return;

  var seriesItem = {};

  for (var key in refSeries) {
    seriesItem[key] = refSeries[key];
  }
  seriesItem.SeriesName = seriesName.toString();
  seriesItem.StackOnField = null;
  seriesItem.GroupOnField = null;
  seriesItem.Color = seriesColor[seriesItem.SeriesName];

  return seriesItem;
}

function buildFormatExpression(conditionalFormat, value) {
  var formatExpression = "";
  switch (conditionalFormat.FormatRule.toLowerCase()) {
    case chartUtils.expressionOperators.greaterthan.toLowerCase():
      formatExpression = Number(value) + ">" + Number(conditionalFormat.FormatValue);
      break;
    case chartUtils.expressionOperators.lessthan.toLowerCase():
      formatExpression = Number(value) + "<" + Number(conditionalFormat.FormatValue);
      break;
    case chartUtils.expressionOperators.equalto.toLowerCase():
      if (value != undefined) formatExpression = "'" + value.toString().toLowerCase() + "' == '" + conditionalFormat.FormatValue.toLowerCase() + "'";else if (value != undefined && conditionalFormat.FormatValue != undefined) formatExpression = "'" + value.toString().toLowerCase() + "' == '" + conditionalFormat.FormatValue.toLowerCase() + "'";else if (conditionalFormat.FormatValue != undefined) formatExpression = "'" + value + "' == '" + conditionalFormat.FormatValue.toLowerCase() + "'";else formatExpression = "'" + value + "' == '" + conditionalFormat.FormatValue + "'";
      break;
    case chartUtils.expressionOperators.greaterthanorequalto.toLowerCase():
      formatExpression = Number(value) + ">=" + Number(conditionalFormat.FormatValue);
      break;
    case chartUtils.expressionOperators.lessthanorequalto.toLowerCase():
      formatExpression = Number(value) + "<=" + Number(conditionalFormat.FormatValue);
      break;
    case chartUtils.expressionOperators.notequalto.toLowerCase():
      if (value != undefined) formatExpression = "'" + value.toString().toLowerCase() + "' == '" + conditionalFormat.FormatValue.toLowerCase() + "'";else if (value != undefined && conditionalFormat.FormatValue != undefined) formatExpression = "'" + value.toString().toLowerCase() + "' != '" + conditionalFormat.FormatValue.toLowerCase() + "'";else if (conditionalFormat.FormatValue != undefined) formatExpression = "'" + value + "' != '" + conditionalFormat.FormatValue.toLowerCase() + "'";else formatExpression = "'" + value + "' != '" + conditionalFormat.FormatValue + "'";
      break;
    case chartUtils.expressionOperators.contains.toLowerCase():
      if (value != undefined) formatExpression = "'" + value.toString().toLowerCase() + "' .includes('" + conditionalFormat.FormatValue.toLowerCase() + "')";else if (conditionalFormat.FormatValue != undefined) formatExpression = "'" + value + "' .includes('" + conditionalFormat.FormatValue.toLowerCase() + "')";else formatExpression = "'" + value + "' .includes('" + conditionalFormat.FormatValue + "')";
      break;
    case chartUtils.expressionOperators.startswith.toLowerCase():
      if (value != undefined) formatExpression = "'" + value.toString().toLowerCase() + "' == '" + conditionalFormat.FormatValue.toLowerCase() + "'";else if (value != undefined && conditionalFormat.FormatValue != undefined) formatExpression = "'" + value.toString().toLowerCase() + "' .startsWith('" + conditionalFormat.FormatValue.toLowerCase() + "')";else if (conditionalFormat.FormatValue != undefined) formatExpression = "'" + value + "' .startsWith('" + conditionalFormat.FormatValue.toLowerCase() + "')";else formatExpression = "'" + value + "' .startsWith('" + conditionalFormat.FormatValue + "')";
      break;
    case chartUtils.expressionOperators.endswith.toLowerCase():
      if (value != undefined) formatExpression = "'" + value.toString().toLowerCase() + "' == '" + conditionalFormat.FormatValue.toLowerCase() + "'";else if (value != undefined && conditionalFormat.FormatValue != undefined) formatExpression = "'" + value.toString().toLowerCase() + "' .endsWith('" + conditionalFormat.FormatValue.toLowerCase() + "')";else if (conditionalFormat.FormatValue != undefined) formatExpression = "'" + value + "' .endsWith('" + conditionalFormat.FormatValue.toLowerCase() + "')";else formatExpression = "'" + value + "' .endsWith('" + conditionalFormat.FormatValue + "')";
      break;
  }

  return formatExpression;
}

function buildSeriesData(data, groupField, categories, seriesData) {
  if (data == null || groupField == null || categories == null) return;

  if (seriesData == null) seriesData = {};

  for (var i in categories) {
    var category = categories[i];
    var subset = filter(data, groupField, category);
    if (subset == null) subset = [];
    seriesData[category] = JSON.stringify(subset);
  }
  return seriesData;
}

function getSubArray(array, subset, fieldName) {
  if (array == null || subset == null) return;

  if (array.length < subset.length) return array;

  var temp = [];
  for (var i = 0; i < subset.length; i++) {
    var d = subset[i];
    var item = findInArray(array, fieldName, d[fieldName]);
    if (item != null) temp.push(item);
  }

  return temp;
}
function getTimeMeridian(time) {
  if (time == null) return;
  if (time.toString().toLowerCase().indexOf("am") >= 0) return "AM";
  if (time.toString().toLowerCase().indexOf("pm") >= 0) return "PM";
  return "";
}

function getHourNumber(time) {
  if (time == null) return;
  var regex = /[:. ]/g;
  var hourNumber = time.toString().split(regex)[0];
  return hourNumber;
}

function isSpecialSort(fieldName) {
  for (var i = 0; i < chartUtils.sortList.length; i++) {
    var item = chartUtils.sortList[i];
    if (fieldName.toLocaleLowerCase().indexOf(item) > -1) return true;
  }
  return false;
}

function getLabelColor(colorScheme, i) {
  if (colorScheme == null) return;
  if (typeof i == "undefined") {
    if (colorScheme.length < 4) {
      color = colorScheme + colorScheme.slice(1);
    }
  } else {
    var colors = [];
    while (colors.length <= i) {
      colors.push.apply(colors, colorScheme);
    }for (var index = i; index <= colors.length; index++) {
      var color = colors[index];
      if (color.length < 4) {
        color += color.slice(1);
      }
    }

    var rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
    rgb = {
      r: parseInt(rgb[1], 16),
      g: parseInt(rgb[2], 16),
      b: parseInt(rgb[3], 16)
    };
    var brightness = (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    return brightness > 127 ? "#000" : "#fff";
  }
}

function getUpperFirst(configs) {
  return configs.map(function (item) {
    return mapKeys(item, function (value, key) {
      return upperFirst(key);
    });
  });
}

export default chartUtils;